import React from 'react';

const Result = ({ result }) => {
    return (
        <div className="result">
           <p>{result.length > 25 ? 'Overflow' : result}</p>
        </div>
    );
}

export default Result;



// WEBPACK FOOTER //
// ./src/component/result.jsx